import { AlertCircleIcon, Loader2Icon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/shadcn/utils';

interface ProviderMarkProps {
  /** The provider's name, e.g. "Slack": the mark's label and status text. */
  provider: string;
  /** The provider's own logo, so the screen shows the method the user picked. */
  logo: ReactNode;
  failed?: boolean;
}

/**
 * The sign-in provider's logo on an OAuth callback screen, badged with a
 * spinner while the sign-in finishes or an alert once it failed.
 */
export const ProviderMark = ({
  provider,
  logo,
  failed = false,
}: ProviderMarkProps) => (
  <div className="relative mb-5 size-14">
    <div
      role="img"
      aria-label={provider}
      className="flex size-full items-center justify-center rounded-2xl border bg-white shadow-xs"
    >
      {logo}
    </div>
    <span
      className={cn(
        'absolute -right-2 -bottom-2 flex size-6 items-center justify-center rounded-full ring-2 ring-white',
        failed ? 'bg-destructive text-white' : 'bg-background border',
      )}
    >
      {failed ? (
        <AlertCircleIcon className="size-4" aria-hidden="true" />
      ) : (
        <Loader2Icon
          className="text-foreground/70 size-3.5 motion-safe:animate-spin"
          aria-hidden="true"
        />
      )}
    </span>
    {!failed && (
      <span role="status" className="sr-only">
        Signing you in with {provider}
      </span>
    )}
  </div>
);
